import React, { useEffect, useState } from 'react';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // Force dark mode on body for the entire app
  useEffect(() => {
    document.documentElement.classList.add('dark');
    document.body.classList.add('dark', 'bg-background', 'text-foreground');
  }, []);
  const handleLogin = () => {
    setIsAuthenticated(true);
  };
  const handleLogout = () => {
    setIsAuthenticated(false);
  };
  return <div className="min-h-screen bg-background text-foreground dark" data-id="element-0">
      {isAuthenticated ? <Dashboard onLogout={handleLogout} data-id="element-1" /> : <Login onLogin={handleLogin} data-id="element-2" />}
    </div>;
}